/** Parse a filename and extract the file extension excluding the period. */
export function getFileExtension(fileName: string) {
  const periodIndex = fileName.lastIndexOf('.');
  return periodIndex >= 0 ? fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) : null;
}
